import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

interface AssertivaResult {
  sucesso: boolean;
  from_cache: boolean;
  resultado: any;
  protocolo: string | null;
  consulta_id?: string;
  erro?: string;
}

export function useAssertivaConsulta() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const queryClient = useQueryClient();

  const consultar = async (
    tipo: 'cpf' | 'cnpj' | 'email' | 'telefone' | 'nome',
    chave: string,
    options?: { autoSecundarias?: boolean; finalidade?: number; lead_id?: string }
  ): Promise<AssertivaResult | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const { data, error: fnError } = await supabase.functions.invoke('assertiva-consulta', {
        body: {
          tipo,
          chave,
          finalidade: options?.finalidade || 4,
          autoSecundarias: options?.autoSecundarias || false,
          lead_id: options?.lead_id || null,
        },
      });

      if (fnError) {
        const msg = fnError.message || 'Erro ao consultar Assertiva';
        setError(msg);
        toast.error(msg);
        return null;
      }

      if (data?.sucesso) {
        toast.success(data.from_cache ? 'Dados carregados do cache' : 'Consulta realizada com sucesso');
        // Invalidate contact queries
        queryClient.invalidateQueries({ queryKey: ['assertiva-contatos'] });
        queryClient.invalidateQueries({ queryKey: ['assertiva-socios'] });
      } else if (data?.erro) {
        setError(data.erro);
        toast.error(`Erro Assertiva: ${data.erro}`);
      }

      return data as AssertivaResult;
    } catch (err: any) {
      const msg = err.message || 'Erro inesperado';
      setError(msg);
      toast.error(msg);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { consultar, isLoading, error };
}
